




























































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import notificationService from '@/services/notificationService';
import { DxForm, DxItem, DxSimpleItem, DxGroupItem, DxLabel, DxRequiredRule } from 'devextreme-vue/form';

import SaveBar from '@/modules/shared/savebar/SaveBar.vue';
import Card from '@/components/default/Card.vue';

import TaskTemplatesRepository from '@/modules/tasks/templates/TaskTemplatesRepository';
import TaskInstructionsRepository from '@/modules/tasks/shared/TaskInstructionsRepository';
import EmployeesRepository from '@/modules/employees/employeesRepository';

import employeesRepository from '@/modules/employees/employeesRepository';
import { CreateTaskTemplateCommand, ICreateTaskTemplateCommand, IUpdateTaskTemplateCommand, TaskTemplateDto, TaskTemplatesClient, UpdateTaskTemplateCommand } from '@/data/web-api-client';

Component.registerHooks(['beforeRouteLeave']);

@Component({
  components: {
    DxForm,
    DxItem,
    DxSimpleItem,
    DxGroupItem,
    DxLabel,
    DxRequiredRule,
    SaveBar,
    Card,
  },
})
export default class TaskTemplateDetailsPage extends Vue {
  public dto: ICreateTaskTemplateCommand | IUpdateTaskTemplateCommand = {
    title: '',
    category: '',
    description: '',
    team: '',
    assignedUserId: '',
    name: '',
    instructionId: '',
    nextTaskTemplateId: '',
  };

  employees: any[] = [];
  instructions: any[] = [];
  loading: boolean = false;
  saving: boolean = false;
  initialised: boolean = false;
  dirty: boolean = false;

  taskTemplatesClient = new TaskTemplatesClient(undefined, this.$axios);
  taskTemplates: TaskTemplateDto[] = [];

  async save() {
    try {
      this.saving = true;
      const form: any = this.$refs.form;
      const validationResult = form.instance.validate();

      if (validationResult.isValid) {
        if (this.id) {
          await this.taskTemplatesClient.putItem(this.id, this.dto as UpdateTaskTemplateCommand);
        } else {
          // create
          const res = await this.taskTemplatesClient.postItem(this.dto as CreateTaskTemplateCommand);
          this.dirty = false;
          this.$router.push({ path: `/tasks/templates/${res.data}` });
        }
        notificationService.saved();
        this.dirty = false;
      } else {
        notificationService.invalidForm();
      }
    } catch (err) {
      notificationService.showAxiosError(err);
    } finally {
      this.saving = false;
    }
  }

  async loadEmployees() {
    try {
      this.employees = (await EmployeesRepository.get()).data;
    } catch {
      notificationService.showErrorMessage('Mislukt om de werknemers te laden!');
    }
  }

  async loadInstructions() {
    try {
      this.instructions = (await TaskInstructionsRepository.getAll()).data;
    } catch {
      notificationService.showErrorMessage('Mislukt om de handleidingen te laden!');
    }
  }

  async loadData() {
    try {
      this.loading = true;
      const res = await this.taskTemplatesClient.getItem(this.id);
      Object.assign(this.dto, res);
      setTimeout(() => {
        this.initialised = true;
      }, 300);
    } catch (error) {
      notificationService.showErrorMessage('Er is iets misgelopen tijdens het laden van de template!');
    } finally {
      this.loading = false;
    }
  }

  async created() {
    if (this.id) {
      this.loadData();
    } else {
      this.initialised = true;
    }
    this.taskTemplates = await this.taskTemplatesClient.getAll();
    this.loadEmployees();
    this.loadInstructions();
  }

  beforeRouteLeave(to: any, from: any, next: any) {
    if (this.dirty) {
      if (confirm('Er zijn onopgeslagen wijzigingen. Bent u zeker dat u wenst te veranderen van pagina?')) {
        next();
      } else {
        next(false);
      }
    } else {
      next();
    }
  }

  get title() {
    return this.id ? 'Taak template wijzigen' : 'Taak template aanmaken';
  }

  get id() {
    return this.$route.params.id;
  }

  get nextTaskTemplateOptions() {
    return {
      items: this.taskTemplates.filter((tt) => tt.id != this.id),
      displayExpr: 'name',
      valueExpr: 'id',
      showClearButton: true,
    };
  }

  get employeesOptions() {
    return {
      items: this.employees?.filter((o: any) => o.accountEnabled === true),
      displayExpr: 'displayName',
      valueExpr: 'adUserId',
    };
  }

  get instructionsOptions() {
    return {
      items: this.instructions,
      displayExpr: 'name',
      valueExpr: 'key',
    };
  }

  get rolesOptions() {
    return {
      items: employeesRepository.getTeams(),
      displayExpr: 'text',
      valueExpr: 'value',
    };
  }

  get categoryOptions() {
    return {
      items: this.$store.getters['catalogs/list']('TaskCategories').values,
      searchEnabled: false,
      showClearButton: true,
      showCancelButton: true,
    };
  }

  @Watch('dto', { deep: true })
  onDtoChanged() {
    if (this.initialised) {
      this.dirty = true;
    }
  }
}
